module.exports = __webpack_public_path__ + "static/img/bgLogo01.717422c9.png";